import ApiClient from '../ApiClient';

class CrmAutomationsAPI extends ApiClient {
    constructor() {
        super('crm/automations', { accountScoped: true });
    }

    getWhatsappTemplates(inboxId) {
        return axios.get(`${this.url}/whatsapp_templates`, {
            params: { inbox_id: inboxId },
        });
    }
}

export default new CrmAutomationsAPI();
